import { useModel, useRoute } from "@bcm-dev/bcms-vite";
import PageView from "compid/shared/containers/PageViewContainer";
import { useRef, } from "react";
import "./styles.css";




export default function ZellePage(props) {
  let model = useModel();
  let ref = useRef(null);
  const navigate = useRoute();
  const branding = useModel().branding.options;

 let src =  `/bcms/click/zelle/?b=${model.b}&c=${branding.zle_courseid_rxp22}#send-money`;

  var timer = setInterval(function(){
      try{          
        ref.current.contentWindow.document.querySelector('html').style.overflow = "hidden";
        ref.current.height = 1000;			
      }catch(err){
        if (ref.current ){
          ref.current.height = 1000;
        }
      
        //window.clearInterval(timer)
      }})
  return (
    <PageView className="zelle-page">

      {/*START: page sub header*/}
      <div className="page-sub-header">
        <span className="semi-bold-text payment-link"  onClick={ () => navigate(`/paybills`) } data-point="back_to_payments">Payments</span>
      </div>
      {/*END: page sub header*/}

  

   
        
         <iframe  src={src}  ref={ref}/>
      


    </PageView>
  )
}